module.exports = __webpack_public_path__ + "static/media/education-landscape.8a70afce.jpg";